/**
 * ч.1296: картка правої рейки ПН/РК — звернення до комісії ДПС щодо зупиненої
 * реєстрації (пояснення / додаткові пояснення / скарга) з їх станом.
 */
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { erpnAppeals, KIND_SHORT, RESULT_LABELS } from '@/api/erpnAppeals';

export const SUB_STATUS_UK: Record<string, string> = {
  DRAFT: 'чернетка у Кабінеті ДПС',
  SIGNED: 'підписано',
  SENT: 'відправлено',
  DELIVERED: 'доставлено, рішення очікується',
  ACCEPTED: 'прийнято ДПС',
  REJECTED: 'не прийнято ДПС',
  ERROR: 'помилка відправки',
};

export default function ErpnAppealsCard({ invoiceId, erpnStatus }: {
  invoiceId: string;
  erpnStatus: string;
}) {
  const navigate = useNavigate();
  const q = useQuery({
    queryKey: ['erpn-appeals', 'by-invoice', invoiceId],
    queryFn: () => erpnAppeals.list({ invoice_id: invoiceId, limit: 50 }),
  });
  const items = q.data?.items ?? [];
  const stopped = ['STOPPED', 'BLOCKED', 'REJECTED', 'ERROR'].includes(erpnStatus);
  if (!items.length && !stopped) return null;
  const go = (kind: 'EXPLANATION' | 'ADDITIONAL' | 'COMPLAINT') =>
    navigate(`/erpn-appeals/new?invoice=${invoiceId}&kind=${kind}`);
  return (
    <div className="docrail__card" data-testid="erpn-appeals-card">
      <div className="docrail__title">Оскарження зупинення реєстрації</div>
      {items.length === 0 && (
        <div style={{ fontSize: '0.8rem', color: 'var(--muted)', marginBottom: '0.4rem' }}>
          звернень до комісії ДПС ще немає
        </div>
      )}
      {items.map((a) => (
        <div key={a.id} style={{ fontSize: '0.8rem', marginBottom: '0.35rem' }}>
          <a style={{ cursor: 'pointer', color: 'var(--primary)' }}
            onClick={() => navigate(`/erpn-appeals/${a.id}`)}>
            {KIND_SHORT[a.kind]} від {new Date(a.document_date).toLocaleDateString('uk-UA')}
          </a>
          <div style={{ color: 'var(--muted)' }}>
            {a.result ? RESULT_LABELS[a.result]
              : SUB_STATUS_UK[a.submission_status ?? ''] ?? 'не подано'}
          </div>
        </div>
      ))}
      {stopped && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem', marginTop: '0.4rem' }}>
          {erpnStatus === 'REJECTED' ? (
            <a style={{ cursor: 'pointer', color: 'var(--primary)', fontSize: '0.85rem' }}
              onClick={() => go('COMPLAINT')}>подати скаргу на відмову →</a>
          ) : (
            <a style={{ cursor: 'pointer', color: 'var(--primary)', fontSize: '0.85rem' }}
              onClick={() => go('EXPLANATION')}>подати пояснення та копії документів →</a>
          )}
          {items.some((a) => a.kind === 'EXPLANATION') && erpnStatus !== 'REJECTED' && (
            <a style={{ cursor: 'pointer', color: 'var(--primary)', fontSize: '0.85rem' }}
              onClick={() => go('ADDITIONAL')}>додаткові пояснення на запит комісії →</a>
          )}
        </div>
      )}
    </div>
  );
}
